var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('nav-bar'),_c('div',{staticClass:"main"},[_c('banner'),_c('about'),_c('gallery'),_c('Announcement',{attrs:{"is-gray":true}}),_c('report'),_c('faq')],1),_c('site-footer',{attrs:{"show-subscribe":true}}),_c('copyright'),_c('floating-icon')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }